import { Typography } from "@mui/material"
import type { FC, ReactNode } from "react"

interface GoodsReceiptDetailsInfoItemProps {
  label: string
  children: ReactNode
  "data-testid"?: string
}

export const GoodsReceiptDetailsInfoItem: FC<GoodsReceiptDetailsInfoItemProps> = ({
  label,
  children,
  "data-testid": testId,
}) => {
  return (
    <Typography
      variant='body2'
      component='div'
      className='flex items-center gap-x-2 text-gray-700'
      data-testid={testId}
    >
      {label}
      {children}
    </Typography>
  )
}
